import { Controller } from '@hotwired/stimulus';

/**
 * DeleteCategoryModalController
 *
 * 投資適合性カテゴリ削除の共通モーダル。
 * トリガーボタンの data-* 属性からカテゴリ情報を読み取り、モーダルの中身と
 * 削除リンクの href / data-confirm を動的に書き換える。
 *
 * 各カテゴリ行で個別モーダルを描画するのを避け、DOM 数を抑える。
 */
export default class extends Controller {
  static targets = ['name', 'answerType', 'optionsCount', 'answerCount', 'deleteLink'];

  connect() {
    this.element.addEventListener('show.bs.modal', this.populate);
  }

  disconnect() {
    this.element.removeEventListener('show.bs.modal', this.populate);
  }

  populate = (event) => {
    const button = event.relatedTarget;
    if (!button) return;

    const { categoryName, categoryAnswerType, optionsCount, answerCount, deleteUrl, confirmMessage } = button.dataset;

    this.nameTargets.forEach((el) => { el.textContent = categoryName ?? ''; });
    this.answerTypeTarget.textContent = categoryAnswerType ?? '';
    this.optionsCountTarget.textContent = optionsCount ?? '';
    this.answerCountTargets.forEach((el) => { el.textContent = answerCount ?? ''; });

    this.deleteLinkTarget.setAttribute('href', deleteUrl ?? '#');
    this.deleteLinkTarget.dataset.confirm = confirmMessage ?? '';
  };
}
